import io from 'socket.io-client';

import { socketURL } from '../../util/Constant';
import { socketConnected, socketDisconnected, socketReceiveMessage, setServerOffline } from '../redux/socketSlice';
// import { socketConnected, socketDisconnected, socketReceiveMessage, setServerOffline, socketTimerSync } from '../redux/socketSlice';
import { getAllPrintFileFetch, getFalseSewnFileFetch} from '../action/fetchPrint';
import { getAllStatusForArchiveFetch, getNewStatusFetch } from '../action/fetchStatus';
import { getNewSmsFetch } from '../action/fetchSMS';
import { getAllHpFileFetch } from '../action/fetchHp';

// Assuming you have a base URL defined elsewhere

export const socketMiddleware = (store) => (next) => {
  let socket;
  let reconnectTimer = null;

  const clearSocket = () => {
    if (socket) {
      socket.removeAllListeners();
      socket.close();
      socket = null;
    }
    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
  };

  const connectSocket = () => {
    clearSocket();

    socket = io(socketURL, {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 60000,
    });

    socket.io.on("reconnect_attempt", (attempt) => {
      console.log(`Попытка переподключения ${attempt}`);
    });

    socket.io.on("reconnect", (attempt) => {
      console.log(`Успешное переподключение после ${attempt} попыток`);
      store.dispatch(setServerOffline(false));
    });

    socket.io.on("reconnect_failed", () => {
      console.log("Не удалось переподключиться после всех попыток");
      store.dispatch(setServerOffline(true));
      clearSocket();
      // Пробуем переподключиться через 1 минуту
      reconnectTimer = setTimeout(connectSocket, 60000);
    });

    socket.on('connect', () => {
      console.log('Socket.io connected');
      store.dispatch(setServerOffline(false));
      window.__socket__ = socket;
      next(socketConnected());
    });

    socket.on('connect_error', (error) => {
        console.log('Connection error:', error);
        // Если это ошибка соединения, можно сразу показать offline, 
        // но обычно лучше подождать реконнектов. 
        // Однако если пользователь хочет сразу видеть ошибку при старте:
        store.dispatch(setServerOffline(true));
    });

    socket.on('disconnect', (reason) => {
      console.log('Socket.io disconnected:', reason);
      if (reason === "io server disconnect" || reason === "transport close") {
        store.dispatch(setServerOffline(true));
      }
      next(socketDisconnected());
    });

    socket.on('message', (data) => {
      next(socketReceiveMessage(data));
    });

    socket.on('print', (data) => {
      next(socketReceiveMessage(data));
      store.dispatch(getAllPrintFileFetch());
    });
    socket.on('hp', (data) => {
      next(socketReceiveMessage(data));
      store.dispatch(getAllHpFileFetch());
    });
    
    socket.on('sewn', (data) => {
      next(socketReceiveMessage(data));
      store.dispatch(getFalseSewnFileFetch());
    });

    socket.on('status', () => { 
      //console.log("status");
      store.dispatch(getNewStatusFetch());
      store.dispatch(getAllStatusForArchiveFetch());
    });

    socket.on('push', () => { 
      //console.log("push");
      store.dispatch(getNewSmsFetch());
    });
    
    // socket.on('timer', (data) => {
    //   store.dispatch(socketTimerSync(data));
    // });
    
    // Обработка ошибок
    socket.on('error', (error) => {
      console.error('Socket error:', error);
      clearSocket();
      reconnectTimer = setTimeout(connectSocket, 5000);
    });

    return socket;
  };

  return (action) => {
    const result = next(action);
    
    if (!socket) {
      connectSocket();
    }
    
    return result;
  };
};

export const getSocket = () => {
  return window.__socket__;
};

export const setSocketInstance = (socketInstance) => {
  window.__socket__ = socketInstance;
};
